import { createContext } from 'react';
var AppContext = createContext({
  modalContainer: null,
  pubSub: null
});
export default AppContext;